module.exports = __webpack_public_path__ + "static/PHorde3gold-1eb6238d469aa4769a8e0bce07300eab.png";